// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React, { Component } from 'react';
import _ from 'underscore';

import { localizeCount } from '@trello/i18n';

import { recupWithHelpers } from 'app/scripts/views/internal/recupWithHelpers';
import { PowerUpItemType } from 'app/src/components/PowerUp';
import { BaseDirectoryView } from './BaseDirectoryView';
import { DirectoryPluginItemView } from './DirectoryPluginItemView';
const t = recupWithHelpers('directory');

class DirectorySearchComponent extends Component {
  static initClass() {
    // @ts-expect-error TS(2339): Property 'displayName' does not exist on type 'Dir... Remove this comment to see the full error message
    this.prototype.displayName = 'Directory Search';

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.prototype.render = t.renderable(function (this: any) {
      return t.div('.directory-content-body', () => {
        if (this.props.isEmpty) {
          return t.div('.directory-search-empty', () => {
            return t.p(() => {
              t.formatText('bummer-no-search-results-for');
              return t.span(() => {
                return t.text(`"${this.props.searchTerm}"`);
              });
            });
          });
        } else {
          t.div('.results-header', () => {
            return t.h2(() =>
              t.text(
                localizeCount('count-results-for', this.props.length, {
                  query: this.props.searchTerm,
                }),
              ),
            );
          });
          return t.div('.directory-listing');
        }
      });
    });
  }
}

DirectorySearchComponent.initClass();

interface DirectorySearchView extends BaseDirectoryView {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  appendSubviews: any;
}

class DirectorySearchView extends BaseDirectoryView {
  eventSource() {
    return 'boardDirectorySearch';
  }

  renderContent() {
    return (
      <DirectorySearchComponent
        // @ts-expect-error TS(2769): No overload matches this call.
        searchTerm={this.options.searchTerm}
        isEmpty={_.isEmpty(this.options.plugins)}
        length={this.options.plugins.length}
      />
    );
  }

  render() {
    // @ts-expect-error TS(2556): A spread argument must either have a tuple type or... Remove this comment to see the full error message
    super.render(...arguments);
    const contentContainer = this.$el.find('.directory-listing');
    contentContainer.empty();

    const { plugins, currentPage, directoryView } = this.options;

    const pluginViews = _.map(plugins, (plugin) => {
      return this.subview(
        DirectoryPluginItemView,
        this.model,
        {
          atomType: PowerUpItemType.Description,
          currentPage,
          plugin,
          directoryView,
        },
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        plugin.id,
      );
    });

    this.appendSubviews(pluginViews, contentContainer);

    const enabledPlugins = directoryView.getEnabledPlugins();
    const listedPowerUpsEnabled = _.intersection(
      _.map(plugins, 'id'),
      _.map(enabledPlugins, 'id'),
    );

    directoryView.trackScreenEvent(
      this.eventSource(),
      {
        totalListed: plugins.length,
        totalListedEnabled: listedPowerUpsEnabled.length,
        totalEnabled: enabledPlugins.length,
        allPowerUpsEnabled: _.map(enabledPlugins, 'id'),
      },
      listedPowerUpsEnabled,
    );
    return this;
  }
}

export { DirectorySearchView };
